// extracted by mini-css-extract-plugin
export default {"vendorContract":"A9zTbe3pTTNr0kM935Qp","hero":"r85QIzwVNWa1VM7nzEQF","buttonBox":"E5aB7J3rMuHm18CVrau3","startSigning":"Lj3O2reVZgvRCgb0kWye","small":"P39lLp1d8RrUma3z6994"};